import styled from 'styled-components';

// Responsive grid width, mirroring suit's `pages/plan` GridWrapper so the
// `Cards` grid steps 1 → 2 → 3 columns at the same breakpoints.
const GridWrapper = styled.div`
  @media (min-width: 400px) {
    width: 304px;
  }

  @media (min-width: 720px) {
    width: 624px;
  }

  @media (min-width: 1040px) {
    width: 944px;
  }
`;

export { GridWrapper };
